
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';

import DebtsFsSurvey from "./DebtsFSSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import PageBase from "../../PageBase.vue";


import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        DebtsFsSurvey,
      PageBase
    }
})
export default class DebtsFS extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void
    

    @Watch('creditorData')
    creditorDataChange(newVal) 
    {
        this.UpdateStepResultData({step:this.step, data: {debtsFSSurvey: this.getCreditorResults()}})  
    }

    currentStep =0;
    currentPage =0;
    showTable = true;
    creditorData = [];
    anyRowToBeEdited = null;
    editId = null;
 
    created() {
        if (this.step.result?.debtsFSSurvey?.data) {
            this.creditorData = this.step.result.debtsFSSurvey.data;
        }
    }

    mounted(){        
        const progress = this.creditorData?.length>0? 100 : 50;            
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
        Vue.nextTick(()=>{
            const el = document.getElementById('debts-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {
        this.showTable = value;
    }

    public populateSurveyData(creditorValue) {
        const currentIndexValue = this.creditorData?.length > 0 ? this.creditorData[this.creditorData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newCreditor = { ...creditorValue, id };

        this.creditorData = this.creditorData? [...this.creditorData, newCreditor]:[newCreditor];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
        this.creditorData = this.creditorData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
    }

    public editRow(editedRow) {
        this.creditorData = this.creditorData.map(data => {
            return data.id == this.editId ? editedRow : data;
        });
        this.showTable = true;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    public isDisableNext() {    
        if(this.creditorData?.length > 0) return false;
        else return true;
    }    

    beforeDestroy() {
        const progress = this.creditorData?.length>0? 100 : 50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data:{debtsFSSurvey: this.getCreditorResults()}})       
    }
   
    public getCreditorResults(){
        const questionResults: {name:string; value: string[]; title:string; inputType:string}[] =[];
        if(this.creditorData)
            for(const creditor of this.creditorData)
            {
                questionResults.push({name:'debtsFSSurvey', value: this.getCreditorInfo(creditor), title:'Creditor '+creditor.id +' Information', inputType:''})
            }

        return {data: this.creditorData, questions:questionResults, pageName:'Debts', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getCreditorInfo(creditor){        
        const resultString: string[] = [];
        resultString.push(Vue.filter('styleTitle')("Name: ")+creditor.creditorName);
        resultString.push(Vue.filter('styleTitle')("Reason For Borrowing: ")+creditor.reasonForBorrowing);
        resultString.push(Vue.filter('styleTitle')("Balance Owing: ")+creditor.balanceOwing);
        return resultString
    }

}
